import React from 'react';
import './PaginationControls.css';

const PaginationControls = ({ total, page, limit, onPageChange, onLimitChange }) => {
  const totalPages = Math.ceil(total / limit);
  
  const createPaginationItems = () => {
    const items = [];
    
    if (totalPages <= 9) {
      // If 9 or fewer pages, show all pages
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <li key={i} className={`page-item ${i === page ? 'active' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); onPageChange(i); }}>
              {i}
            </a>
          </li>
        );
      }
    } else {
      // Smart pagination for many pages
      const showPages = [];
      
      // Always show first page
      showPages.push(1);
      
      // Calculate range around current page
      const startPage = Math.max(2, page - 3);
      const endPage = Math.min(totalPages - 1, page + 3);
      
      // Add ellipsis after first page if needed
      if (startPage > 2) {
        showPages.push('...');
      }
      
      // Add pages around current page
      for (let i = startPage; i <= endPage; i++) {
        showPages.push(i);
      }
      
      // Add ellipsis before last page if needed
      if (endPage < totalPages - 1) {
        showPages.push('...');
      }
      
      // Always show last page
      if (totalPages > 1) {
        showPages.push(totalPages);
      }
      
      // Render the pagination items
      showPages.forEach((item, index) => {
        if (item === '...') {
          items.push(
            <li key={`ellipsis-${index}`} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        } else {
          items.push(
            <li key={item} className={`page-item ${item === page ? 'active' : ''}`}>
              <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); onPageChange(item); }}>
                {item}
              </a>
            </li>
          );
        }
      });
    }
    
    return items;
  };

  return (
    <div className="pagination-controls">
      <nav aria-label="Page navigation example">
        <ul className="pagination">
          <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); onPageChange(page - 1); }}>
              &laquo;
            </a>
          </li>
          {createPaginationItems()}
          <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); onPageChange(page + 1); }}>
              &raquo;
            </a>
          </li>
        </ul>
      </nav>
      <select className="form-select" value={limit} onChange={onLimitChange} style={{ width: 'auto' }}>
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={20}>20</option>
      </select>
    </div>
  );
};

export default PaginationControls;
